<template>
  <v-tabs
    :class="$style.tabs"
    v-bind="$attrs"
    v-on="$listeners"
    slider-color="accent darken-4"
    slider-size="4"
    :active-class="$style.activeTab"
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />

    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-tabs>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Tabs extends Vue {}
</script>

<style module lang="scss">
.tabs {
  :global(.v-tab) {
    line-height: 1.5;
    text-transform: none;
    letter-spacing: normal;
  }

  :global(.v-tabs-bar) {
    background-color: transparent !important;
  }

  :global(.v-tab.v-tab:not(.v-tab--active)) {
    color: $primary_base !important;
  }

  :global(.v-slide-group__content) {
    border-bottom: 2px solid $primary_base;
  }

  :global(.v-tabs-slider-wrapper) {
    bottom: -2px;
  }

  :global(.v-slide-group__prev) {
    display: none !important;
  }

  :global(.v-slide-group__next) {
    display: none !important;
  }
}

.activeTab {
  color: $primary_darken1 !important;
}
</style>
